(function($) {

	var methods = {

		init:function(options) {

			var config = {
				'type': 'slider',
				'autoPlay': true,
				'clickNext': true,
				'fadeButtons': true,
				'duration': 15000,
				'nextButtonSelector': '.button_next',
				'previousButtonSelector': '.button_previous',
				'navButtonsAreChildren': true,
				'withNavBullets': false,
				'numberNavBullets': false,
				'startSlide': 0,
				'loop': true,
			};

			if (options) { $.extend(config,options); }

			return this.each(function() {

				var $slideshow = $(this);
				$slideshow.addClass('slideshow');

				// makes config variables available for the instance / for thumbs v2
				var data = $slideshow.data();
				data.config = config;

				var $currentSlide;
				var $currentSlideClone;
				var slideshowTimeout = null;
				var reverseDirection = false;
				var $slideHolder = $slideshow.find('.slideHolder');
				var $slides = $slideHolder.find('.slide:visible');
				var $navItems = $('.slideshowNavItem');


				$slideshow.data('slides', $slides);
				$currentSlide = $slides.eq(0);
				$currentSlide.addClass('activeSlide');


				// resize slides
				var slideshowWidth = $slideshow.width();
				var slideshowHeight = $slideshow.height();
				$slides.width(slideshowWidth);
				$slides.height(slideshowHeight);

				// wire up next and previous butons
				var $nextButton;
				var $previousButton;
				if (config.navButtonsAreChildren) {
					$previousButton = $slideshow.find(config.previousButtonSelector);
					$nextButton = $slideshow.find(config.nextButtonSelector);
				} else {
					$previousButton = $(config.previousButtonSelector);
					$nextButton = $(config.nextButtonSelector);
				}

				$nextButton.click(function() {
					stopSlideshow();
					doNextSlide();
				});

				$previousButton.click(function() {
					stopSlideshow();
					doPreviousSlide();
				});


				$slideshow.hover(
					function() {
						// TODO: can do with CSS transitions
						if (config.fadeButtons) {
							$previousButton.stop().fadeTo('slow',0.2);
							$nextButton.stop().fadeTo('slow',0.2);
						}
						clearTimeout(slideshowTimeout);
					},
					function() {
						// TODO: can do with CSS transitions
						if (config.fadeButtons) {
							$previousButton.stop().fadeTo('slow',0.5);
							$nextButton.stop().fadeTo('slow',0.5);

						}
						if (config.autoPlay) { // restart slideshow
							slideshowTimeout = setTimeout(function() {doNextSlide()},1000);
						}
					}
				);

				// TODO: can do with CSS transitions
				if (config.fadeButtons) {
					$previousButton.hover(
						function() {$previousButton.stop().fadeTo('slow',0.5);},
						function() {$previousButton.stop().fadeTo('slow',0.2);}
					);

					$nextButton.hover(
						function() {$nextButton.stop().fadeTo('slow',0.5);},
						function() {$nextButton.stop().fadeTo('slow',0.2);}
					);
				}

				// wireup single slide click
				if (config.clickNext) {
					$slides.click(function () {
						stopSlideshow();
						doNextSlide();
					});
				}




				// initialize for different transitions
				if (config.type =='slider') {
					var slideHolderWidth = slideshowWidth * $slides.length;
					$slideHolder.height(slideshowHeight);
					$slideHolder.width(slideHolderWidth);
				} else if (config.type =='vertical') {
					//slideHolder.width(slideshowWidth);
					$slideHolder.height(slideshowHeight * $slides.length);
				} else if (config.type =='fader') {
					$slideHolder.children('.slide').addClass('fader-slide');
				}


				if (config.autoPlay) { // begin slideshow
					slideshowTimeout = setTimeout(function() {doNextSlide()}, config.duration);
				}


				var doNextSlide = function() {

					var nextIndex = $slides.index($currentSlide) + 1;

					if (nextIndex == $slides.length) {
						nextIndex = 0;
					}

					var $nextSlide = $slides.eq(nextIndex);
					reverseDirection = false;

					if (
							(nextIndex !== 0) ||
							((nextIndex === 0) && (config.loop))
					) {
						activateSlide($nextSlide);
					}

					if (config.autoPlay) {
						slideshowTimeout = setTimeout(function() {doNextSlide()}, 5000);
					}
				};

				var doPreviousSlide = function() {

					var previousIndex = $slides.index($currentSlide) - 1;

					if (previousIndex == -1) {
						previousIndex = $slides.length - 1;
					}

					var $previousSlide =  $slides.eq(previousIndex);
					reverseDirection =  true;

					if (
							(previousIndex != $slides.length - 1) ||
							((previousIndex == $slides.length - 1) && (config.loop))
					) {
						activateSlide($previousSlide);
					}
				};

				var stopSlideshow = function() {
					clearTimeout(slideshowTimeout);
					config.autoPlay =  false;
				};

				var runSlideAnimation = function($slide) {

					var animateFunction = $slide.data('animate');
					if (animateFunction) {
						window[animateFunction]();
					}
				};



				var activateSlide = function($slide) {

					if ($currentSlide != $slide) { // for buttons/thumbs

						var $previousSlide = $currentSlide;
						$currentSlide = $slide;
						$slideshow.data('currentSlide', $currentSlide);

						$slideshow.find('.activeSlide').removeClass('activeSlide');
						$slide.addClass('activeSlide');

						if (config.withNavBullets) {
							var slideIndex = $slides.index($slide);
							var $list = $slideshow.find('ul.list_navBullets');
							$list.find('li.active').removeClass('active');
							var $bullet = $list.find('li:nth-child(' + (slideIndex + 1) + ')');
							$bullet.addClass('active');
						}

						$navItems.removeClass('active');

						if ($slide.data('nav')) {
							var id = $slide.data('nav');
							var $navItem = $('#' + id);
							$navItem.addClass('active');
						}

						var resetFunction = $slide.data('reset');
						if (resetFunction) {
							window[resetFunction]();
						}


						if (config.type =='slider') {

							if ($currentSlideClone) {
								$currentSlideClone.remove();
							}

							slideshowWidth = $slideshow.width(); // recalculate in case slideshow size changed

							// handle forward loop
							var newLeft;
							if (($slides.index($slide) == 0) && (reverseDirection == false)) {

								$currentSlideClone = $slide.clone();

								$slideHolder.width($slideHolder.width() + slideshowWidth);
								$slideHolder.append($currentSlideClone);
								//newLeft = 0 - ($slideHolder.width() - slideshowWidth);
								newLeft = 0 - $currentSlideClone.position().left;

							// handle reverse loop
							} else if (($slides.index($slide) == $slides.length - 1) && (reverseDirection)) {

								$currentSlideClone = $slide.clone();
								$slideHolder.prepend($currentSlideClone);

								$slideHolder.css('left', 0 - slideshowWidth);


								newLeft = 0;

							} else {



								//newLeft = 0 - ($slides.index($slide) * slideshowWidth);
								newLeft = 0 - $slide.position().left;
							}


							// handle slide
							$slideHolder.stop().animate({left: newLeft}, 500, 'swing', function() {

								// run animation if it exists
								runSlideAnimation($slide);

								// handle forward loop
								if (($slides.index($slide) == 0) && (reverseDirection == false)) {
// TODO: $slides.index($slide) == 0 > won't work!!!! same as below


									$currentSlideClone.remove();
									$slideHolder.width($slideHolder.width() - slideshowWidth);
									$slideHolder.css('left', 0);


								// handle reverse loop
								} else if (($slides.index($slide) == $slides.length - 1) && (reverseDirection)) {

//									$slideHolder.css('left', 0 - $slideHolder.width() + slideshowWidth);
									$currentSlideClone.remove();
									$slideHolder.width($slideHolder.width() - slideshowWidth);
									$slideHolder.css('left', 0 - $slide.position().left); // must get left after removing slide
								}

							});

						} else if (config.type =='vertical') {

							var newTop;

							// handle downward loop
							if (($slides.index($slide) == 0) && (reverseDirection == false)) {

								$slideHolder.append($slide);
								$slideHolder.css('padding-top', slideshowHeight);
								newTop = 0 - ($slideHolder.height());



							// handle upward loop
							} else if (($slides.index($slide) == $slides.length - 1) && (reverseDirection)) {

								$slideHolder.prepend($slide);
								$slideHolder.css('top', 0 - slideshowHeight);
								newTop = 0;

							} else {

								newTop = 0 - ($slides.index($slide) * slideshowHeight);
							}


							// handle slide
							$slideHolder.stop().animate({top: newTop}, 500, function() {

								// handle upward loop
								if (($slides.index($slide) == 0) && (reverseDirection == false)) {

									$slideHolder.prepend($slide);
									$slideHolder.css('padding-top',0);
									$slideHolder.css('top', 0);

								// handle downard loop
								} else if (($slides.index($slide) == $slides.length - 1) && (reverseDirection)) {

									$slideHolder.append($slide);
									$slideHolder.css('top', 0 - $slideHolder.height() + slideshowHeight);

								}


							});




						} else if (config.type =='fader') {

							$previousSlide.fadeOut(1000);
							$slide.css('left', 0);
							$slide.fadeIn(1000);

						}

					}
				}



				var createNavBullets = function($slides) {

					var $bulletList = $(document.createElement('ul')).addClass('list_navBullets no-bullets');
					var count = 1;
					$slides.each(function() {
						var $slide = $(this);
						var $bullet = createNavBullet($slide, count);
						$bulletList.append($bullet);
						count ++;
					});

					$slideshow.append($bulletList);
				};

				var createNavBullet = function($slide, count) {
					var $listItem = $(document.createElement('li'));
					if (count == 1) {
						$listItem.addClass('active');
					}
					if (config.numberNavBullets) {
						$listItem.text(count);
					}

					$listItem.click(function() {
						activateSlide($slide);
					});

					return $listItem;
				};

				if (config.withNavBullets) {
					createNavBullets($slides);
				}

				/*
				var recenterSlide = function() {

					slideshowWidth = slideshow.width(); // recalculate in case slideshow size changed
					//slidesARR.width(slideshowWidth); // resize slides in case there are rounding errors
					var newLeft = 0-(slidesARR.index(currentSlide)*slideshowWidth);
					var slideHolderWidth = (slideshowWidth*(slidesARR.length));
					slideHolder.width(slideHolderWidth);
					slideHolder.css('left', newLeft + 'px');
				}
				*/




				if (config.startSlide !== 0) {
					activateSlide($slideshow.data('slides').eq(config.startSlide));
				}

				runSlideAnimation($currentSlide);

			});

		},
		/*
		activate: function() { // for thumbs/v2


			$($(this).data('currentSlide')).fadeOut(1000);
			$($(this).data('slidesARR')[0]).fadeIn();


		},

		moveToSlide: function(slideNumber) {
			activateSlide($(this).data('slidesARR')[slideNumber]);
			stopSlideshow();
		},

		recenter: function() {
			recenterSlide();
		},

		nextSlide: function() {
			doNextSlide();
		},

		previousSlide: function() {
			doPreviousSlide();
		},

		getCurrentNavItem: function() {
			return currentNavItem;
		},
		*/
		destroy: function() {
			var $slideshow = $(this);
			$slideshow.removeClass('slideshow');
			$slideshow.find('.slideHolder').css('width', '');
			$slideshow.find('.slideHolder').css('left', '');
			if ($slideshow.data('slides')) {
				if ($slideshow.data('slides').length > 0) {
					$slideshow.data('slides').css('width', '');
					$slideshow.data('slides').css('height', '');
				}
			}

		},

	};



		$.fn.slideshow = function(method) {

			// Method calling logic
			if ( methods[method] ) {
				return methods[ method ].apply( this, Array.prototype.slice.call( arguments, 1 ));
			} else if ( typeof method === 'object' || ! method ) {
				return methods.init.apply( this, arguments );
			} else {
				$.error( 'Method ' +  method + ' does not exist on jQuery.evolvecreate.slideshow' );
			}

		};

		// TODO: move to separate javascript

		// slideshows for blogs
		$(document).ready(function() {
			if ($(window).width() < 768) {
				$('.slideshow_blog').slideshow({autoPlay: false, fadeButtons: false, clickNext: false});
			}
		}, 500); // wait for styles

		$(window).on('resize', function(){
			if ($(window).width() < 768) {
				$('.slideshow_blog:not(.slideshow)').slideshow({autoPlay: false, fadeButtons: false, clickNext: false});
			} else {
				$('.slideshow_blog').slideshow('destroy');
			}
		});

		// grant stories
		$(document).ready(function() {
			setTimeout(function() {
				$('.slideshow_grant-stories').slideshow({
					autoPlay: true,
					fadeButtons: false,
					clickNext: false,
					withNavBullets: true,
					numberNavBullets: true,
				});
			}, 500);  // wait for styles
		});

		// translate
		$(document).ready(function() {

			setTimeout(function() {
				$('.wp-block-gallery').each(function () {

					var $slideshowHolder = $(this);
					var width = $slideshowHolder.width();
					var height = $slideshowHolder.height();
					width = 566;
					height = 428;

					$slideshowHolder.addClass('slideHolder no-bullets')
							.removeClass('wp-block-gallery columns-2 is-cropped');
					$slideshowHolder.find('.blocks-gallery-item').addClass('slide')
							.removeClass('blocks-gallery-item');

					var $slideshow = $(document.createElement('div')).addClass('slideshow_gallery');
					$slideshow.css('width', width + 'px');
					$slideshow.css('height', height + 'px');
					$slideshowHolder.after($slideshow);
					$slideshow.append($slideshowHolder);

					var $previousButton = $(document.createElement('div')).addClass('button_previous');
					var $nextButton = $(document.createElement('div')).addClass('button_next');
					$slideshow.append($previousButton);
					$slideshow.append($nextButton);


					$slideshow.slideshow({
						autoPlay: false,
						fadeButtons: false,
						clickNext: true,
						withNavBullets: true,
						numberNavBullets: false,
					});

				});
			}, 500);
		});


})( jQuery );



// WEBPACK FOOTER //
// ./scripts/jquery.evolvecreate.slideshow-2.4.js